import { render, staticRenderFns } from "./FacultyDashboardLanding.vue?vue&type=template&id=cb80771e&scoped=true&"
import script from "./FacultyDashboardLanding.vue?vue&type=script&lang=js&"
export * from "./FacultyDashboardLanding.vue?vue&type=script&lang=js&"
import style0 from "./FacultyDashboardLanding.vue?vue&type=style&index=0&id=cb80771e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80771e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDivider,VHover,VIcon,VSkeletonLoader,VSnackbar})
